<script setup>
import ProductManagementForm from '@frontJs/components/forms/projectManagement/sea/ProductManagementForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, googleAdsProductManagement, variableInformation } = defineProps(
    {
        tenant: {
            type: Object,
            required: true,
        },
        googleAdsProductManagement: {
            type: Object,
            required: false,
        },
        variableInformation: {
            type: Object,
            required: true,
        },
    },
);

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="googleAdsProductManagement">
            Mettre à jour le pilotage shopping #{{
                googleAdsProductManagement.id
            }}
            - Pilotage Shopping - SEA - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un pilotage shopping - Pilotage Shopping - SEA - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="googleAdsProductManagement" :tenant-name="tenant.name">
        Gestion de projet - SEA - Pilotage Shopping - Mettre à jour le pilotage
        shopping #{{ googleAdsProductManagement.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEA - Pilotage Shopping - Créer un pilotage shopping
    </PageTitle>

    <ProductManagementForm
        :tenant="tenant"
        :google-ads-product-management="googleAdsProductManagement"
        :variable-information="variableInformation"
    />
</template>
